module.exports = __webpack_public_path__ + "img/icon-tick.96eb53fb.svg";